import styled from 'styled-components';

export const Container = styled.div`
  padding: 2rem 0;

  .img-responsive {
    display: block;
    width: 100%;
    height: auto;
  }

  .tab-pagination-title {
    display: flex;
    gap: 1rem;
    justify-content: center;

    .tab-pagination-title-item {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--gray_light_light);
      border: 1px solid var(--gray_light);
      border-radius: 0.4rem;
      color: var(--gray);
      padding: 1.1rem 0;
      cursor: pointer;
      width: 15rem;
      max-height: 3.5rem;

      &:hover {
        background-color: var(--gray_light);
      }

      img {
        max-width: 3rem;
        padding: 0.5rem;
      }
    }
  }

  .description-block {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin-top: 3rem;

    .title {
      color: var(--gray);
      text-align: center;
      font-size: 2rem;
      font-weight: 900;

      &::after {
        content: '';
        width: 100px;
        height: 5px;
        background: var(--primary_color);
        display: table;
        margin: 10px auto;
      }
    }
  }

  .additional-info {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 1440px) {
    padding: 2rem 1rem;
  }

  @media (max-width: 1000px) {
    .tab-pagination-title {
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      .tab-pagination-title-item {
        width: 100%;
      }
    }
  }

  @media (max-width: 530px) {
    .tab-pagination-title {
      grid-template-columns: 1fr;
    }
  }
`;
